import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoClose } from "react-icons/io5";

import { db } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

export default function EditProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setFormData({ id: docSnap.id, ...docSnap.data() });
        } else {
          console.log("No such product!");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, [id]);

  if (!formData) return <p>Loading...</p>;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: name === "price" || name === "oldprice" ? Number(value) : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const docRef = doc(db, "products", id);

      await updateDoc(docRef, {
        name: formData.name,
        price: formData.price,
        oldprice: formData.oldprice,
      });

      alert("Product Updated Successfully");
      navigate("/admin/products");
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  return (
    <section className="add-product-page">
      <div className="product-form-page">
        <h2>Edit Product</h2>
        <hr />

        <form onSubmit={handleSubmit}>
          <label>Enter Name :</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>Enter Price :</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            required
          />

          <label>Old Price :</label>
          <input
            type="number"
            name="oldprice"
            value={formData.oldprice}
            onChange={handleChange}
          />

          <button type="submit">Update Product</button>
        </form>
      </div>

      <div className="cancel-button">
        <IoClose
          className="close"
          onClick={() => navigate("/admin/products")}
        />
      </div>
    </section>
  );
}
